







import { Vue, Component, Prop } from 'vue-property-decorator';
import RedButton from './RedButton.vue';
import TransferIcon from '../icon/TransferIcon.vue';
@Component({ components: { TransferIcon, RedButton } })
export default class TransferButton extends Vue {}
